export function prefixedClassName(className) {
    return "rkc-".concat(className);
}
//# sourceMappingURL=prefixedClassName.js.map